import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const MoreAddressApi = createApi({
  reducerPath: "MoreAddressApi",
  baseQuery,
  tagTypes: ["Entity"],
  endpoints: (builder) => ({
        

    getMoreAddressByMasterId: builder.query({
      query: ({id} ) => `/customers/moreAddresses/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
          console.log(normalized,'normalizedmoreaddress');
        return normalized.map((item) => ({
          ...item,
          id: item.customerMoreAddressId, 
        }));
      },
      providesTags: ["MoreAddress"],
    }),
    

    // 🔄 UPDATE entity
    updateMoreAddress: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/customers/moreAddresses/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { moreAddresses: data }, 

      }),
      invalidatesTags: ["MoreAddress"],
    }),

    // 🔄 DELETE entity
    deleteMoreAddress: builder.mutation({
      query: ({ id,subId }) => ({
        url: `/customers/moreAddresses/${id}/${subId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["MoreAddress"],
    }),

    // 🔄 CREATE entity
    createMoreAddress: builder.mutation({
      query: ({ id, ...data }) => {    
        const requestBody = { moreAddresses: data };    
        return {
          url: `/customers/moreAddresses/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: requestBody,
        };
      },
      invalidatesTags: ["MoreAddress"],
    }),
    
  }),
});

export const {
  useGetMoreAddressByMasterIdQuery,
  useLazyGetMoreAddressByMasterIdQuery,
  useUpdateMoreAddressMutation,
  useDeleteMoreAddressMutation,
  useCreateMoreAddressMutation,
} = MoreAddressApi;
